import Badge from "@components/shared/badge/Badge";
import LinkButton from "@components/shared/form/linkButton";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { GQLPosts, GQLUrls } from "@gql/types/gql";
import { translate } from "@helpers/translationObjectFormatter";
import {
    resolveNewsTagsColor,
    resolveURL,
    resolveNewsTagName,
} from "@lib/sharedUtils";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import { titleDecoder } from "@lib/sharedUtils";

const HeroSection = ({ news }: { news: GQLPosts[] | undefined }) => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);
    return news && news.length ? (
        <div className="relative h-full  pb-20">
            <div
                className="h-[100%]"
                style={{
                    position: "absolute",
                    backgroundImage: `url(${
                        news?.[0]?.image?.fullPath as string
                    })`,
                    width: "100vw",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }}
            />
            <div
                className="h-[100%]"
                style={{
                    position: "absolute",
                    backgroundImage: `url(${
                        news?.[0]?.image?.fullPath as string
                    })`,
                    width: "100vw",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    opacity: "0.7",
                    filter: "brightness(0) saturate(100%) invert(13%) sepia(44%) saturate(1754%) hue-rotate(192deg) brightness(95%) contrast(100%)",
                }}
            />
            <div className="relative flex flex-col sm:flex-row gap-16 pt-[5rem]">
                <div className="flex flex-col items-start gap-10">
                    {news?.[0]?.tags && news?.[0]?.tags?.length > 0 && (
                        <Badge
                            text={
                                resolveNewsTagName(
                                    news?.[0]?.tags as { name: string }[],
                                ) as string
                            }
                            variant="green"
                            className="capitalize"
                        />
                    )}
                    <h1 className="text-white font-bold text-3xl sm:text-6xl max-w-2xl">
                        {titleDecoder(news[0]?.title ?? "")}
                    </h1>
                    <div className="w-full max-w-[200px]">
                        <LinkButton
                            href={resolveURL(news[0].url as GQLUrls)}
                            className="bg-transparent border hover:bg-transparent w-full"
                        >
                            {translate(
                                translations,
                                "several_general_readMoreButton",
                            )}
                        </LinkButton>
                    </div>
                </div>
                <div className="sm:w-[536px] w-full mx-auto lg:mx-0">
                    <div className="text-white bg-[#FFFFFF1A] p-7 flex flex-col gap-6 ">
                        <h2 className="font-bold text-3xl">
                            {translate(
                                translations,
                                "several_news_popularToday",
                            )}
                        </h2>
                        {news?.slice(1)?.map((post) => (
                            <a
                                href={post.url?.url as string}
                                key={post.id}
                                className={`cursor-pointer text-white hover:no-underline`}
                            >
                                <div className="flex items-center gap-4">
                                    <div className="w-full max-w-[170px]">
                                        <img
                                            src={post.image?.fullPath as string}
                                            alt={post.title as string}
                                        />
                                    </div>
                                    <div className=" flex flex-col justify-between ">
                                        <div className="mb-3 sm:text-base text-xs capitalize">
                                            {post.tags &&
                                                post.tags.length > 0 && (
                                                    <Badge
                                                        text={
                                                            resolveNewsTagName(
                                                                post?.tags as {
                                                                    name: string;
                                                                }[],
                                                            ) as string
                                                        }
                                                        variant={resolveNewsTagsColor(
                                                            resolveNewsTagName(
                                                                post?.tags as {
                                                                    name: string;
                                                                }[],
                                                            ) as string,
                                                        )}
                                                        className="h-fit"
                                                    />
                                                )}
                                        </div>
                                        <p className="max-w-[357px] sm:font-bold font-semibold sm:text-base text-xs">
                                            {titleDecoder(post.title ?? "")}
                                        </p>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <></>
    );
};

export default HeroSection;
